import React from "react";
import {
  Paper,
  Table,
  TableCell,
  TableHead,
  TableContainer,
  TableRow,
  TableBody,
  useMediaQuery,
  Box,
  Typography,
} from "@material-ui/core";
import { getUnitName } from "../../../utils/loadTypeUtils";

export const LocationInventories = ({ inventoryItems }) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  return inventoryItems.length === 0 ? (
    <Paper variant="outlined">
      <Box m={4} display="flex" alignContent="center" justifyContent="center">
        <Typography variant="body1">No Inventories found</Typography>
      </Box>
    </Paper>
  ) : (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{isSmall ? "Product" : "Product Name"}</TableCell>
            <TableCell>Account</TableCell>
            <TableCell>{isSmall ? "Onhd" : "Quantity Onhand"}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {inventoryItems?.length > 0 &&
            inventoryItems.map((inventoryItem) => (
              <TableRow key={inventoryItem.id}>
                <TableCell>{inventoryItem.inventory.productName}</TableCell>
                <TableCell>{inventoryItem.inventory.accountName}</TableCell>
                <TableCell>{`${inventoryItem.quantityOnHand} ${
                  !isSmall
                    ? getUnitName(inventoryItem.inventory.inventoryUOM)
                    : ""
                }`}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
